import React from 'react';
import {
  TableRow as MUITableRow,
  TableRowProps as MUITableRowProps,
} from '@mui/material';

export const TableRow = (props: MUITableRowProps) => {
  return <MUITableRow {...props} />;
};
